(function () {
  const gallerySelector = '.tikoo-card-gallery';
  const imageSelector = '[data-tikoo-card-gallery-image]';
  const dataSelector = '[data-tikoo-card-gallery-data]';
  const countSelector = '[data-tikoo-card-gallery-count]';
  const previousSelector = '[data-tikoo-card-gallery-previous]';
  const nextSelector = '[data-tikoo-card-gallery-next]';
  const hoverClass = 'tikoo-card-gallery-hover';
  let hoveredGalleryWrapper = null;

  function parseImages(gallery) {
    if (gallery.tikooGalleryImages) return gallery.tikooGalleryImages;

    const dataNode = gallery.querySelector(dataSelector) || gallery.closest('.card__media')?.querySelector(dataSelector);
    if (!dataNode) {
      gallery.tikooGalleryImages = [];
      return gallery.tikooGalleryImages;
    }

    try {
      const rawContent = dataNode.content?.textContent || dataNode.textContent || '[]';
      const parsed = JSON.parse(rawContent);
      gallery.tikooGalleryImages = Array.isArray(parsed)
        ? parsed.filter((item) => item && typeof item.src === 'string' && item.src.length > 0)
        : [];
    } catch (error) {
      gallery.tikooGalleryImages = [];
    }

    return gallery.tikooGalleryImages;
  }

  function normalizeIndex(index, total) {
    if (total <= 0) return 0;
    return ((index % total) + total) % total;
  }

  function preloadImage(imageData) {
    if (!imageData || imageData.preloaded || typeof Image === 'undefined') return;

    const image = new Image();
    image.onload = () => {
      imageData.loaded = true;
    };
    image.onerror = () => {
      imageData.loaded = true;
    };
    if (imageData.srcset) image.srcset = imageData.srcset;
    image.src = imageData.src;
    imageData.preloaded = true;
  }

  function preloadNeighbors(images, index) {
    if (images.length <= 1) return;

    preloadImage(images[normalizeIndex(index + 1, images.length)]);
    preloadImage(images[normalizeIndex(index - 1, images.length)]);
  }

  function updateCount(gallery, index, total) {
    const count = gallery.closest('.card__media')?.querySelector(countSelector) || gallery.querySelector(countSelector);
    if (!count) return;

    count.textContent = `${index + 1} / ${total}`;
  }

  function setLoading(gallery, isLoading) {
    gallery.classList.toggle('is-loading', isLoading);
  }

  function commitImage(gallery, image, imageData, index, token) {
    const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;
    const transitionDelay = prefersReducedMotion ? 0 : 80;
    window.setTimeout(() => {
      if (gallery.dataset.tikooGalleryToken !== token) return;
      if (imageData.srcset) {
        image.setAttribute('srcset', imageData.srcset);
      } else {
        image.removeAttribute('srcset');
      }

      image.src = imageData.src;
      image.alt = imageData.alt || '';
      if (imageData.width) image.width = imageData.width;
      if (imageData.height) image.height = imageData.height;

      preloadNeighbors(parseImages(gallery), index);
      image.classList.remove('is-switching');
      setLoading(gallery, false);
    }, transitionDelay);
  }

  function loadThenCommitImage(gallery, image, imageData, index, token) {
    if (imageData.loaded || typeof Image === 'undefined') {
      commitImage(gallery, image, imageData, index, token);
      return;
    }

    const loader = new Image();
    const commit = () => {
      imageData.loaded = true;
      commitImage(gallery, image, imageData, index, token);
    };

    loader.onload = commit;
    loader.onerror = commit;
    if (imageData.srcset) loader.srcset = imageData.srcset;
    loader.src = imageData.src;
  }

  function applyImage(gallery, index) {
    const images = parseImages(gallery);
    if (images.length === 0) return;

    const normalizedIndex = normalizeIndex(index, images.length);
    const imageData = images[normalizedIndex];
    const image = gallery.querySelector(imageSelector);
    if (!image || !imageData) return;

    const nextToken = (Number.parseInt(gallery.dataset.tikooGalleryToken || '0', 10) || 0) + 1;
    const token = nextToken.toString();
    gallery.dataset.tikooGalleryToken = token;
    gallery.dataset.tikooGalleryIndex = normalizedIndex.toString();
    updateCount(gallery, normalizedIndex, images.length);
    image.classList.add('is-switching');
    setLoading(gallery, true);
    loadThenCommitImage(gallery, image, imageData, normalizedIndex, token);
  }

  function moveGallery(gallery, direction) {
    const images = parseImages(gallery);
    if (images.length <= 1) return;

    const currentIndex = Number.parseInt(gallery.dataset.tikooGalleryIndex || '0', 10);
    const nextIndex = Number.isNaN(currentIndex) ? 0 : currentIndex + direction;
    applyImage(gallery, nextIndex);
  }

  function initializeGallery(gallery) {
    if (gallery.dataset.tikooGalleryReady === 'true') return;

    const images = parseImages(gallery);
    if (images.length <= 1) return;

    gallery.dataset.tikooGalleryReady = 'true';
    gallery.dataset.tikooGalleryIndex = '0';
    images[0].loaded = true;
    updateCount(gallery, 0, images.length);
    preloadNeighbors(images, 0);
  }

  function initializeGalleries(root) {
    root.querySelectorAll?.(gallerySelector).forEach(initializeGallery);
  }

  function isPointInsideElement(event, element) {
    if (!element || typeof event.clientX !== 'number' || typeof event.clientY !== 'number') return false;

    const rect = element.getBoundingClientRect();
    return (
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom
    );
  }

  function setGalleryHoverWrapper(wrapper) {
    if (hoveredGalleryWrapper === wrapper) return;

    hoveredGalleryWrapper?.classList.remove(hoverClass);
    hoveredGalleryWrapper = wrapper || null;
    hoveredGalleryWrapper?.classList.add(hoverClass);
  }

  function updateGalleryHoverState(event) {
    const target = event.target;
    const wrapper = target?.closest?.('.card-wrapper');
    if (!wrapper) {
      setGalleryHoverWrapper(null);
      return;
    }

    const shell = wrapper.querySelector('.tikoo-card-gallery-shell');
    if (!shell) {
      setGalleryHoverWrapper(null);
      return;
    }

    setGalleryHoverWrapper(isPointInsideElement(event, shell) ? wrapper : null);
  }

  function clearGalleryHoverState(event) {
    if (event.relatedTarget === null) {
      setGalleryHoverWrapper(null);
    }
  }

  function findButtonByPoint(event, selector) {
    if (typeof document === 'undefined') return null;

    return Array.from(document.querySelectorAll(selector)).find((button) => isPointInsideElement(event, button)) || null;
  }

  function findGalleryButton(event) {
    const target = event.target;
    const previousButton = target?.closest?.(previousSelector) || findButtonByPoint(event, previousSelector);
    const nextButton = target?.closest?.(nextSelector) || findButtonByPoint(event, nextSelector);

    if (previousButton) {
      return {
        button: previousButton,
        direction: -1,
      };
    }

    if (nextButton) {
      return {
        button: nextButton,
        direction: 1,
      };
    }

    return null;
  }

  function releasePointerFocus(button, event) {
    // 鼠标点击按钮后浏览器会把焦点留在按钮上，CSS 的 focus-within 会让控制层一直显示。
    // 键盘触发的 click 通常 detail 为 0，需要保留焦点，方便继续用 Tab / Enter 操作图集。
    if (event.detail > 0 && typeof button.blur === 'function') {
      button.blur();
    }
  }

  function handleGalleryButtonClick(event) {
    // Shopify 主题脚本可能在 section 重载时重复执行；同一个 click 事件只允许处理一次。
    if (event.tikooCardGalleryHandled === true) return;

    const matchedButton = findGalleryButton(event);
    if (!matchedButton) return;

    const gallery = matchedButton.button.closest('.card__media')?.querySelector(gallerySelector) || matchedButton.button.closest(gallerySelector);
    if (!gallery) return;

    event.tikooCardGalleryHandled = true;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    moveGallery(gallery, matchedButton.direction);
    releasePointerFocus(matchedButton.button, event);
  }

  if (window.tikooCardGalleryClickBound !== true) {
    window.tikooCardGalleryClickBound = true;
    document.addEventListener('click', handleGalleryButtonClick, true);
  }

  if (window.tikooCardGalleryHoverBound !== true) {
    window.tikooCardGalleryHoverBound = true;
    document.addEventListener('pointermove', updateGalleryHoverState, true);
    document.addEventListener('pointerout', clearGalleryHoverState, true);
    window.addEventListener('blur', () => setGalleryHoverWrapper(null));
  }

  document.addEventListener('DOMContentLoaded', () => initializeGalleries(document));
  document.addEventListener('shopify:section:load', (event) => initializeGalleries(event.target));
})();
